import moment from "moment";
import formatter from '../../../../../utils/formatter';
import { milliToDate } from "../../../../../utils/commonUtil";

export default function apiDataFormatter(apiData) {
 for(let i=0;i<apiData.length;i++){
   let data = apiData[i];
  if(data["amount"] === null || data["amount"] === "" || data["amount"] == 0){
    data["amount"] = "--"
  }else{
    data["amount"] = formatter({
      value: data["amount"],
      fieldSuffix: 'Dollars',
    });
  };
  if(!data["type"]) {data["type"] = "--"};
  if(!data["description"]) {data["description"] = "--"};
  if(!data['allShares'] && (data["noOfShares"] === null || data["noOfShares"] === "" || (data["noOfShares"] === 0))){
    data["noOfShares"] = "--"
  }else{
    // LE-1721, Show 6 digits after the decimal only for complex assets
    data["noOfShares"] = data['allShares'] ? 'All Shares' : (data["type"] && data["type"] === "Special Asset" ? data["noOfShares"].toFixed(6) : data["noOfShares"].toFixed(4));
  }
  if(!data["status"]) {data["status"] = "--"};
  data["enteredDate"] = data["enteredDate"] ? milliToDate(data["enteredDate"]): "--";
  data["settledDate"] = data["settledDate"] ? milliToDate(data["settledDate"]) : "--";
  // LE-1721, Special asset with entered status not need to show received date
  data["receivedDate"] = data["receivedDate"] ? (data["type"] === "Special Asset" && data["status"] === "Entered" ? "--" : milliToDate(data["receivedDate"])) : "--";
 }
let status = [];
apiData.map((data) => {
  if(!status.includes(data.status)){
  status.push(data.status)
  }
});
apiData.sort((a, b) => {
  let dateA = new Date(a.enteredDate), dateB = new Date(b.enteredDate);
  return dateB - dateA ;
});
  return [apiData, status];
}
